import DetailPickup from "./detail";

const routes = [
  {
    path: "/pickup/:id",
    component: DetailPickup,
  },
];

export default routes;
